import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _Immutable$Record2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { HOME } from "../../AddonDiscovery/config/discoverCollections";
import { BAMBOO, BITBUCKET, CONFLUENCE, CROWD, FECRU, HIPCHAT, JIRA, JIRA_SERVICE_DESK } from "../constants/products";
var featuredAddonsHome = {
  title: 'Staff Picks',
  tagline: 'Try out any of these apps curated by our ecosystem team for free. We think they are a great place ' + "to start if you've never tried Atlassian Marketplace apps before.",
  curatedApps: undefined
};
var featuredAddonsJira = {
  title: 'Staff Picks',
  tagline: 'Try out any of these apps curated by our ecosystem team for free. We think they are a great place ' + "to start if you've never tried apps before with Jira.",
  curatedApps: undefined
};
var featuredAddonsJsd = {
  title: 'Staff Picks',
  tagline: 'Your favorite apps for ITSM, customer support and more - right at your fingertips.',
  curatedApps: undefined
};
var featuredAddonsConfluence = {
  title: 'Staff Picks',
  tagline: 'Top apps to transform and improve the way your teams work together, curated by Atlassian to ensure a seamless experience.',
  curatedApps: undefined
};
var featuredAddonsBitbucket = {
  title: 'Staff Picks',
  tagline: "Bitbucket is the Git solution for teams that's flexible, secure, and scalable. " + 'Streamline the development process through integrations and apps to give teams get a ' + 'tool that fits into the fabric of your organization.',
  curatedApps: undefined
};
export var FeaturedAddonsConfig = /*#__PURE__*/function (_Immutable$Record) {
  _inherits(FeaturedAddonsConfig, _Immutable$Record);

  var _super = _createSuper(FeaturedAddonsConfig);

  function FeaturedAddonsConfig() {
    _classCallCheck(this, FeaturedAddonsConfig);

    return _super.apply(this, arguments);
  }

  _createClass(FeaturedAddonsConfig, null, [{
    key: "default_",
    value: function default_() {
      return new FeaturedAddonsConfig();
    }
  }]);

  return FeaturedAddonsConfig;
}(Immutable.Record((_Immutable$Record2 = {}, _defineProperty(_Immutable$Record2, HOME, featuredAddonsHome), _defineProperty(_Immutable$Record2, JIRA, featuredAddonsJira), _defineProperty(_Immutable$Record2, JIRA_SERVICE_DESK, featuredAddonsJsd), _defineProperty(_Immutable$Record2, CONFLUENCE, featuredAddonsConfluence), _defineProperty(_Immutable$Record2, BITBUCKET, featuredAddonsBitbucket), _defineProperty(_Immutable$Record2, HIPCHAT, undefined), _defineProperty(_Immutable$Record2, FECRU, undefined), _defineProperty(_Immutable$Record2, BAMBOO, undefined), _defineProperty(_Immutable$Record2, CROWD, undefined), _Immutable$Record2)));
export var FeaturedAddonsConfigPropType = PropTypes.instanceOf(FeaturedAddonsConfig);